import { notification } from "antd";


export const openNotification = ({ titulo, descripcion, placement }: any) => {
  notification.info({
    message: titulo,
    description: descripcion,
    placement,
  });
};